define(function (require) {
    var $ = require("jquery");
    var introJs = require("intro-js");
    var timerInterop;

    function abandonInterop() {
        // kill the watchdog timer
        clearTimeout(timerInterop);
        introJs.introJs().exit();

        window.location.href = inactivityTimeoutRedirectUrl;
    }

    if ($("#interopTimeout").length) {
        timerInterop = setInterval(abandonInterop, interopTimerMilliseconds);
    }
});
